import { i18nKey, } from "@shared";
export function withdrawFailed(symbol) {
    return { kind: "failed", message: i18nKey("cryptoAccount.sendFailed", { symbol }) };
}
export function withdrawResult(resp, symbol) {
    switch (resp.kind) {
        case "completed":
        case "success":
            return { kind: "sent" };
        case "failed":
        case "error":
        case "offline":
            return withdrawFailed(symbol);
        default:
            return resp;
    }
}
